export default {"src":"/_next/static/media/retention-compliance.2ba60535.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};